import SearchBox from '@root/modules/Sellers/Inquiry/components/Search';
import { Button, Menu } from 'antd';
import { useState } from 'react';
import DataPicker from './DataPicker';
import DropdownAction from './DropdownAction';
import SearchInput from './SearchInput';

interface WrapActionProps {
  getSelect: any;
  getMarket?: any;
  getStatus?: any;
  market?: any;
  status?: any;
  labelSelect: any;
  onChangeSearch: any;
  getDateValue: any;
  typeDrop: any;
  warehouseUploadCsvButton?: boolean;
  warehouseUploadCsvButtonClick?: () => void;
}

function WrapAction({
  getSelect,
  labelSelect,
  getMarket,
  getStatus,
  onChangeSearch,
  market,
  status,
  getDateValue,
  typeDrop,
  warehouseUploadCsvButton,
  warehouseUploadCsvButtonClick
}: WrapActionProps) {
  const menu = [
    {
      id: 1,
      titleSelect: 'Select',
      list: (
        <Menu
          onClick={getSelect}
          items={[
            {
              label: 'Seller Name',
              key: 'name'
            },
            {
              label: 'Product Name',
              key: 'productName'
            }
          ]}
        />
      )
    }
  ];
  const menuDeli = [
    {
      id: 1,
      titleSelect: 'Select',
      list: (
        <Menu
          onClick={getSelect}
          items={[
            {
              label: 'Seller Name',
              key: 'name'
            },
            {
              label: 'Buyer Name',
              key: 'buyerName'
            },
            {
              label: 'Order Number',
              key: 'orderNumber'
            }
          ]}
        />
      )
    }
  ];

  const menuMarket = [
    {
      id: 2,
      titleSelect: 'Market',
      list: (
        <Menu
          onClick={getMarket}
          items={[
            {
              label: 'Amazon',
              key: 'Amazon'
            },
            {
              label: 'Ebay',
              key: 'Ebay'
            },
            {
              label: 'Rakuten',
              key: 'Rakuten'
            },
            {
              label: 'Qoo 10',
              key: 'Qoo10'
            },
            {
              label: 'Office Online Mall',
              key: 'OfficeOnlineMall'
            },
            {
              label: 'Shopee',
              key: 'Shopee'
            },
            {
              label: 'Others',
              key: 'Others'
            }
          ]}
        />
      )
    }
  ];
  const menuStatus = [
    {
      id: 3,
      titleSelect: 'Status',
      list: (
        <Menu
          onClick={getStatus}
          items={[
            {
              label: 'Request',
              key: 'Request'
            },
            {
              label: 'In Delivery',
              key: 'InDelivery'
            },
            {
              label: 'Delivered',
              key: 'Delivered'
            }
          ]}
        />
      )
    }
  ];
  return (
    <div
      className="wrapActions"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '9px',
        marginBottom: '21px'
      }}
    >
      <DataPicker getDate={getDateValue} />
      {typeDrop === 'delivery' ? (
        <>
          {' '}
          {menuDeli.map((item) => {
            return (
              <DropdownAction
                key={item.id}
                titleSelect={labelSelect.label}
                list={item.list}
              />
            );
          })}
        </>
      ) : (
        <>
          {' '}
          {menu.map((item) => {
            return (
              <DropdownAction
                key={item.id}
                titleSelect={labelSelect.label}
                list={item.list}
              />
            );
          })}
        </>
      )}

      <SearchBox
        type="false"
        // onSearchName={onSearchName}
        onChange={(e: any) => onChangeSearch('Value Search', e.target.value)}
      />
      {typeDrop === 'delivery' && (
        <>
          {menuMarket.map((item) => {
            return (
              <DropdownAction
                key={item.id}
                titleSelect={market?.label ? market?.label : 'Market'}
                list={item.list}
              />
            );
          })}
          {menuStatus.map((item) => {
            return (
              <DropdownAction
                key={item.id}
                titleSelect={status?.label ? status?.label : 'Status'}
                list={item.list}
              />
            );
          })}
        </>
      )}

      {warehouseUploadCsvButton && (
        <Button
          style={{
            background: '#2B2C51',
            color: 'white',
            width: '180px',
            height: '46px',
            borderRadius: '6px',
            marginLeft: 'auto'
          }}
          onClick={() =>
            warehouseUploadCsvButtonClick ? warehouseUploadCsvButtonClick() : {}
          }
        >
          💡Upload CSV file
        </Button>
      )}
    </div>
  );
}

export default WrapAction;
